

"use client";

export default function UserPlusIcon({ className = "", ...props }) {
    return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}
            {...props}>
<path d="M18.5553 19.73C22.8941 19.73 26.4113 16.2128 26.4113 11.874C26.4113 7.53526 22.8941 4.01801 18.5553 4.01801C14.2166 4.01801 10.6993 7.53526 10.6993 11.874C10.6993 16.2128 14.2166 19.73 18.5553 19.73Z" stroke="currentColor" strokeWidth="2.47823" strokeMiterlimit="10" strokeLinecap="round"/>
<path d="M32.0803 35.444H2.84125C2.84125 26.7661 9.87737 19.73 18.5553 19.73C21.1595 19.73 23.6171 20.364 25.7794 21.4854C27.2518 22.2495 28.5901 23.2387 29.7445 24.4097" stroke="currentColor" strokeWidth="2.47823" strokeMiterlimit="10"/>
<path d="M27.4233 29.0193H38.6208" stroke="currentColor" strokeWidth="2.47823" strokeMiterlimit="10"/>
<path d="M33.022 34.618V23.4205" stroke="currentColor" strokeWidth="2.47823" strokeMiterlimit="10"/>
</svg>

    );
}